import React, {CSSProperties, FC, FunctionComponent} from "react";
import SlickSlider from "react-slick";
import backIcon from "../../../../images/Icons/back_icn.svg";
import nextIcon from "../../../../images/Icons/next_icn.svg";
import {Box} from "@material-ui/core";

type ButtonProps = {
    onClick?: () => void;
    style?: CSSProperties;
    className?: string;
};

const NextArrow: FunctionComponent<ButtonProps> = ({onClick, className}) =>
    <img src={nextIcon} className={className} onClick={onClick} alt={"button"}/>;

const PrevArrow: FunctionComponent<ButtonProps> = ({onClick, className}) =>
    <img src={backIcon} className={className} onClick={onClick} alt={"button"}/>;

const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    swipe: true,
    arrows: true,
    nextArrow: <NextArrow/>,
    prevArrow: <PrevArrow/>
};

const SummarySlider: FC = ({children}) => (
    <Box style={{width: 554}}>
        <SlickSlider {...sliderSettings}>
            {children}
        </SlickSlider>
    </Box>
);

export default SummarySlider;
